import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const perfisProfissionaisRoutes: Routes = [
  {
    path: 'perfis-profissionais',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./perfis-profissionais.component').then(
            (m) => m.PerfisProfissionaisComponent,
          ),
        data: {
          title: 'Gerenciar Perfis Profissionais',
          roles: [Role.PERFIS_PROFISSIONAIS_CONSULTAR],
          breadcrumb: [
            { label: 'Perfis Profissionais', url: '/perfis-profissionais' },
          ],
        },
      },
      {
        path: 'cadastrar',
        loadComponent: () =>
          import('./perfil-profissional-form/perfil-profissional-form.component').then(
            (m) => m.PerfilProfissionalFormComponent,
          ),
        data: {
          title: 'Cadastrar Perfil Profissional',
          roles: [Role.PERFIS_PROFISSIONAIS_CADASTRAR],
          breadcrumb: [
            { label: 'Perfis Profissionais', url: '/perfis-profissionais' },
            { label: 'Cadastrar', url: '/perfis-profissionais/cadastrar' },
          ],
        },
      },
      {
        path: 'editar/:id',
        loadComponent: () =>
          import('./perfil-profissional-form/perfil-profissional-form.component').then(
            (m) => m.PerfilProfissionalFormComponent,
          ),
        data: {
          title: 'Editar Perfil Profissional',
          roles: [Role.PERFIS_PROFISSIONAIS_EDITAR],
          breadcrumb: [
            { label: 'Perfis Profissionais', url: '/perfis-profissionais' },
            { label: 'Editar', url: '/perfis-profissionais/editar' },
          ],
        },
      },
    ],
  },
];
